import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	editForm: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.edit-form',
		description: 'Label for the item in the meatball menu to edit the form.',
		defaultMessage: 'Edit form',
	},
	openCustomerEdits: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-customer-edits',
		description: 'Label for the item in the meatball menu to open the form for customer edits.',
		defaultMessage: 'Open customer edits',
	},
	openSuccessTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-success-title',
		description: 'Title of the flag shown to the user when a form is opened successfully.',
		defaultMessage: 'Customer edits open on form',
	},
	openSuccessTitleNonJsm: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-success-title-non-jsm',
		description:
			'Title of the flag shown to the user when a form is opened successfully (non JSM project).',
		defaultMessage: 'Edits open on form',
	},
	openFailureTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-failure-title',
		description: 'Title of the flag shown to the user when a form is opened unsuccessfully.',
		defaultMessage: 'We couldn’t open customer edits.',
	},
	openFailureTitleNonJsm: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-failure-title-non-jsm',
		description: 'Title of the flag shown to the user when a form is opened unsuccessfully.',
		defaultMessage: 'We couldn’t open the form for edits.',
	},
	closeCustomerEdits: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-customer-edits',
		description: 'Label for the item in the meatball menu to close the form for customer edits.',
		defaultMessage: 'Close customer edits',
	},
	closeSuccessTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-success-title',
		description: 'Title of the flag shown to the user when a form is closed successfully.',
		defaultMessage: 'Customer edits closed on form',
	},
	closeValidationFailedTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-validation-failed-title',
		description:
			'Title of the flag shown to the user when a form cannot be closed due to validation errors.',
		defaultMessage: 'We couldn’t close customer edits',
	},
	closeValidationFailedDescription: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-validation-failed-description',
		description:
			'Description for the flag shown to the user when a form cannot be closed due to validation errors.',
		defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
	},
	deleteSuccessTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-success-title',
		description: 'Title of the flag shown to the user when a form is deleted successfully.',
		defaultMessage: 'Form deleted',
	},
	deleteFailureTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-failure-title',
		description: 'Title of the flag shown to the user when a form is deleted successfully.',
		defaultMessage: 'We couldn’t delete this form.',
	},
	makeInternal: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-internal',
		description:
			'Label for the item in the meatball menu for making a form visible to service desk only.',
		defaultMessage: 'Make form internal',
	},
	makeInternalTooltip: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-internal-tooltip',
		description:
			'Hover tooltip for the item in the meatball menu for making a form visible to service desk only.',
		defaultMessage: 'Form will be hidden from customers in the portal, and visible to agents only.',
	},
	internalFormSuccess: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.internal-form-success',
		defaultMessage: 'Form made internal only',
		description:
			'Message on the success flag informing customers that their form was made internal.',
	},
	internalFormFailureTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.internal-form-failure-title',
		description: 'Title of the flag shown to the user when a form is made internal unsuccessfully.',
		defaultMessage: 'We couldn’t make form internal.',
	},
	makeExternal: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-external',
		description:
			'Label for the item in the meatball menu for making a form visible to portal customers.',
		defaultMessage: 'Make form external',
	},
	makeExternalTooltip: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-external-tooltip',
		description:
			'Hover tooltip for the item in the meatball menu for making a form visible to portal customers.',
		defaultMessage: 'Form will be shown on the portal and visible to customers.',
	},
	externalFormSuccess: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.external-form-success',
		defaultMessage: 'Form made external for customers',
		description:
			'Message on the success flag informing customers that their form was made external.',
	},
	externalFormFailureTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.external-form-failure-title',
		description: 'Title of the flag shown to the user when a form is made external unsuccessfully.',
		defaultMessage: 'We couldn’t make form external.',
	},
	downloadPdf: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-pdf',
		description: 'Label for the item in the meatball menu to download the form as a PDF.',
		defaultMessage: 'Download PDF',
	},
	downloadPdfTooltip: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-pdf-tooltip',
		description: 'Hover tooltip for the item in the meatball menu to download the form as a PDF.',
		defaultMessage: 'Download the form as a PDF file.',
	},
	downloadXlsx: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-xlsx',
		description: 'Label for the item in the meatball menu to download the form as an XLSX.',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Download XLSX',
	},
	downloadXlsxTooltip: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-xlsx-tooltip',
		description: 'Hover tooltip for the item in the meatball menu to download the form as a XLSX.',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Download the form as a XLSX file.',
	},
	delete: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete',
		description: 'Label for the item in the meatball menu to delete the form.',
		defaultMessage: 'Delete form',
	},
	deleteTooltip: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-tooltip',
		description: 'Hover tooltip for the item in the meatball menu to delete the form.',
		defaultMessage: 'Permanently delete the form.',
	},
	openFormEdits: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-form-edits',
		description:
			'Label for the item in the meatball menu to open the form for edits (non JSM projects).',
		defaultMessage: 'Open for edits',
	},
	closeFormEdits: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-edits',
		description:
			'Label for the item in the meatball menu to close the form for edits (non JSM projects).',
		defaultMessage: 'Close for edits',
	},
	closeFormSuccessTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-success-title',
		description:
			'Title of the flag shown to the user when a form is closed successfully (non JSM projects).',
		defaultMessage: 'Edits closed on form',
	},
	closeFormValidationFailedTitle: {
		id: 'proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-validation-failed-title',
		description:
			'Title of the flag shown to the user when a form cannot be closed due to validation errors (non JSM projects).',
		defaultMessage: 'We couldn’t close edits on the form',
	},
});
